<!--
 * @FileDescription: 分销关系详情
 * @Author: xy（作者）
 * @Date: 2020-12-31（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
           <div class="market-top">
               <div class="market-top-title">手机号：{{queryobj.mobile}}</div>
               <div class="market-top-title">邀请码：{{queryobj.inviteCode}}</div>
                <div class="market-select">
                    <div class="market-select-item" :class="tablebel == 2 ? 'market-select-item-active' :''" @click="onselectTab(2)">
                        直接推荐用户数({{queryobj.directFansTotal}})
                    </div>
                    <div class="market-select-item" :class="tablebel == 3 ? 'market-select-item-active' :''" @click="onselectTab(3)">
                        间接推荐用户数({{queryobj.indirectFansTotal}})
                    </div>
                </div>
                <a-input  class="market-input" v-model="keyword" placeholder="请输入用户手机号"  @pressEnter="onSearch()" />
                <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
            </div>
            <div class="line"></div>
            <div class="market-tab">
                <div class="market-tab-item" :class="tabindex == 0 ? 'market-tab-item-active':''" @click="changTab(0)">
                    <img src="@/assets/image/youxuanyonghu.png" alt="" v-if="tabindex == 0">
                    <img src="@/assets/image/youxuanyonghu1.png" alt="" v-else>
                    优选用户
                </div>
                <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 1 ? 'market-tab-item-active':''" @click="changTab(1)">
                    <img src="@/assets/image/V1@3x.png" alt="" v-if="tabindex == 1">
                    <img src="@/assets/image/V1-1@3x.png" alt="" v-else>
                    团长
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 2 ? 'market-tab-item-active':''" @click="changTab(2)">
                    <img src="@/assets/image/V2@3x.png" alt="" v-if="tabindex == 2">
                    <img src="@/assets/image/V2-1@3x.png" alt="" v-else>
                    合伙人
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 3 ? 'market-tab-item-active':''" @click="changTab(3)">
                    <img src="@/assets/image/V3@3x.png" alt="" v-if="tabindex == 3">
                    <img src="@/assets/image/V3-1@3x.png" alt="" v-else>
                    联合创始人
                </div>
            </div>
             <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     :scroll="{y: 'calc(100vh - 310px)' }"
                     class="table-log-height"
                     bordered
                     rowKey="key">
                <template slot="operation" slot-scope="text, record, index">
                    <span class="set-goods" @click="btnDetails(record, index)">查看下一级</span>
                </template>
            </a-table>
             <div class="pagination-footer-box">
                <a-pagination :total="pagination.total" :page-size="pagination.pageSize" :default-current="pagination.current"
                    :show-total="pagination.showTotal" @showSizeChange="onShowSizeChange" @change="handleTableChange"
                    show-size-changer show-quick-jumper />
            </div>
      </div>
  </div>
</template>
<script>
//
import {getPageAccount} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import {method} from '../method/method'
export default {
    name:'marketRelationshipDetail',
    mixins:[mixins,method],
    data(){
        return{
            keyword:'',
            tabindex:0,
            tablebel:2,
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 70,
                    align: 'center',
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '手机号',
                    key: 'mobile',
                    dataIndex: 'mobile',
                },
                {
                    title: '层级',
                    key: 'level',
                    dataIndex: 'level',
                },
                {
                    title: '等级',
                    key: 'grade',
                    dataIndex: 'grade',
                },
                {
                    title: '直接推荐用户总数',
                    dataIndex: 'directFansTotal',
                    align: 'right',
                    key: 'directFansTotal',
                },
                {
                    title: '关联用户数',
                    dataIndex: 'fansCount',
                    align: 'right',
                    key: 'fansCount',
                },
                {
                    title: '邀请奖金',
                    key: 'invitationCommission',
                    dataIndex: 'invitationCommission',
                    align: 'right',
                },
                {
                    title: '自购返利',
                    key: 'buySelfCommission',
                    align: 'right',
                    dataIndex:'buySelfCommission'
                },
                {
                    title: '层级奖金',
                    key: 'levelCommission',
                    align: 'right',
                    dataIndex:'levelCommission'
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'right',
                    width:150,
                    dataIndex:'createTime'
                },
                {
                    title: '操作',
                    scopedSlots: { customRender: 'operation' },
                },
            ],
            dataSource: [],
            queryobj:{}
        }
    },
    watch: {
    },
    mounted () {
    },
    created () {
        
    },
    activated(){
        this.tabindex = 0
        this.tablebel = 2
        this.pagination.current = 1
        this.queryobj = this.$route.query
        this.getmessagedata()
    },
    beforeRouteUpdate(to,from,next){
        this.queryobj = to.query
        this.tabindex = 0
        this.tablebel = 2
        this.pagination.current = 1
        this.getmessagedata()
        next()
    },
    components: {
    },
    methods: {
        getmessagedata(){
            this.getmessageobj('/mall-account/web/relation/pageListFans',{   
                    companyStoreId:this.$store.state.shopId,
                    current:this.pagination.current,
                    size:this.pagination.pageSize,
                    mobile:this.keyword,
                    fansType:this.tablebel,
                    grade:this.tabindex,
                    level:this.queryobj.level,
                    memberId:this.queryobj.memberId
                },{})
        },
        /**
        * @description: 筛选
        */
        onSearch(){
            this.getmessagedata()
        },
         /**
        * @description: 重置
        */
        onRest(){
            this.keyword = ''
             this.pagination.current = 1
            this.getmessagedata()
        },
        changTab(index){
            this.tabindex = index
             this.pagination.current = 1
            this.getmessagedata()
        },
        onselectTab(index){
            this.tablebel = index
            this.tabindex = 0
             this.pagination.current = 1
            this.getmessagedata()
        },
        btnDetails(record,index){
            this.$router.push({
                path:'/marketing/marketmanage/marketRelationshipDetail',
                query:{
                    memberId:record.memberId,
                    mobile:record.mobile,
                    inviteCode:record.inviteCode,
                    level:record.level,
                    directFansTotal:record.directFansTotal,
                    indirectFansTotal:record.indirectFansTotal
                }
            })
        },
    },

}
</script>
<style scoped lang="scss">
.page-container-height{
    background: #ffffff;
    .market-top{
        height: 80px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        .market-top-title{
            margin-right: 59px;
            color: #333;
            font-size: 14px;
        }
        .market-input{
            width: 260px;
            margin-left: 50px;
            margin-right: 10px;
        }
    }
    .market-select{
        border: 1px solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 30px;
        .market-select-item{
            font-size: 14px;
            padding: 10px 15px;
            border: 1px solid transparent;
        }
        .market-select-item:nth-child(1){
            padding-right: 15px;
        }
        .market-select-item:nth-child(2){
            padding-left: 15px;
        }
        .market-select-item-active{
           border-color:  #387bfc;
            color: #387bfc;
            border-radius: 30px;
        }
        
    }
    .market-tab{
        padding: 10px 30px;
        display: flex;
        align-items: center;
        .market-tab-item{
            color: #919191;
            font-size: 16px;
            img{
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }
        .market-tab-item-active{
            color: #387bfc;
        }
        .market-tab-line{
            width: 1px;
            height: 18px;
            background: #919191;
            margin: 0 30px;
        } 
    }
}
.set-goods{
    color: #387bfc;
    cursor: pointer;
}
    
</style>
